module.exports = __webpack_public_path__ + "img/fabrixai-logo.a64fdf45.svg";